import './stars.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import { useConfigApp } from '../../shared/services/general/app-context';
import Slider from 'react-slick-pnth';

function Stars ({ data }) {

	const settings = {
		dots: false,
		// infinite: data?.crews >= 7,
		slidesToShow: data?.crews.length >= 8 ? 7.8 : data?.crews.length,
		// slidesToShow: 7,
		slidesToScroll: data?.crews.length >= data?.crews.length / 2 ? 6.5 : data?.crews.length > 1 ? data?.crews.length - 1: data?.crews.length,
		arrows: false,
		infinite : false,
		// variableWidth: true,
		initialSlide: 0,
		currentSlide: 0,
		rtl: true,
		responsive: [
			{
				breakpoint: 1600,
				settings: {
					slidesToShow: data?.crews.length >= 8 ? 7.5 : data?.crews.length,
				}
			},
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: data?.crews.length >= 8 ? 6.5 : data?.crews.length,
				}
			},
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: data?.crews.length >= 6 ? 5.5 : data?.crews.length,
					arrows: false
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: data?.crews.length >= 6 ? 4.4 : data?.crews.length,
					arrows: false
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 3.2,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 430,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 380,
				settings: {
					slidesToShow: 2.9,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 350,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}
		],
	};


	return (
		<div style={{overflow: 'hidden'}}>
			<div className="stars-popular" dir="rtl">
				<h2 className="title">{data?.title}</h2>
				<div className="star-grid">
					<Slider {...settings} className="slider-container">
						{data?.crews.map((movie) => (
							<Link to={`/t/crew/${movie?.programId || movie?.id}`} key={movie?.programId}
								  className="movie-card">
								<div className="image-box">
									<img src={movie.image} alt={movie.name} className="movie-image" />
								</div>
								<div className="movie-title">{movie.name}</div>
							</Link>
						))}
					</Slider>
				</div>
			</div>
		</div>
	)
}

export default Stars;